import { Injectable } from '@angular/core';
import { DataService } from '../../architecture/data.service';
import { Result } from '../../architecture/envelopes';
import { Critic } from 'src/app/shared/models/critic.model';

@Injectable({ providedIn: 'root' })
export class CriticsService {
    constructor(private dataService: DataService) { }

    public get() {
        return this.dataService.get<Result<any>>('critical');
    }

    public delete(cod: number) {
        return this.dataService.delete<Result<string>>('critical/' + cod.toString());
    }

    public insert(critic: Critic) {
        return this.dataService.post<Result<Critic>>('critical', critic);
    }

    public update(critic: Critic) {
        return this.dataService.put<Result<Critic>>('critical', critic);
    }


    public getCriticComplete() {
      return this.dataService.get<Result<any>>('critical/complete');
    }

    public getCriticCompleteDetail(id: number) {
      return this.dataService.get<Result<any>>('critical/detail/' + id);
    }
}
